import { Collapse } from 'antd';
import { memo } from 'react';

type DetailsCollapseProps = {
  details: string;
  label?: string;
};

const DetailsCollapse = memo(({ details, label = 'Detalhes' }: DetailsCollapseProps) => {
  return (
    <div className="sm:hidden">
      <Collapse
        ghost
        items={[
          {
            key: '1',
            label,
            children: (
              <span
                className="text-base details-container text-gray-500"
                dangerouslySetInnerHTML={{ __html: details }}
              />
            ),
          },
        ]}
      />
    </div>
  );
});

DetailsCollapse.displayName = 'DetailsCollapse';

export default DetailsCollapse;
